import { array, string, struct } from 'io-ts/Decoder';

import { Category as Tag } from '../tag/Id';

import { Id } from './Id';
import { Link } from './Link';

export const RefItem = struct({
	id: Id,
	link: Link,
	name: string,
	description: string,
	tags: array(Tag),
});
